export const HomepageProjectDescriptionThree = () => {
  return (
    <div className="project-description-container">
      <h2>Fully Captured</h2>
      <p>
        Fully Captured is a website that’s built to pose as an app that allows
        transfering of large data to it’s other app users at once.
      </p>

      {/* <p>
        Functionality includes an interactive dashboard, where users are able to
        fish friends and messages through the search function. App also
        implements a robust data fetching and handling using the Fetch API to
        interact with a JSON Server database, ensuring reliable and efficient
        data retrieval.
      </p> */}
    </div>
  );
};
